export default "__VITE_ASSET__AQxnJj0L__"